module.exports = __webpack_public_path__ + "img/Skating_1413_1.c92c2cfa.jpg";